import { gql } from '@apollo/client'

export const SERVICE_GET_QUERY = gql`
  query ServiceGet($site: String!) {
    serviceGet(site: $site) {
      siteBaseUrl
      backendUrl
      service {
        id
        siteInternalName
        isLaunched
        networks {
          name
          identifier
          image
          isActive
          isDefault
        }
        serviceName
        serviceType
        serviceTypes
        templateName
        languageCode
        forceLogin
        isMonetizationModelEnabled
        domainName
      }
    }
  }
`
export const SERVICE_BRAND_GET = gql`
  query ServiceGet($site: String!) {
    serviceGet(site: $site) {
      service {
        networks {
          name
          identifier
          image
          isActive
          isDefault
        }
      }
    }
  }
`
